const GUEST_ID_KEY = 'ctrl-enter-guest-id';
import { randomUUID } from '@ctrl-enter/tools/utils';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

function readFromCookie(): string | null {
  try {
    const match = document.cookie.split(';').find(c => c.trim().startsWith(`${GUEST_ID_KEY}=`));
    return match ? decodeURIComponent(match.trim().split('=')[1] ?? '') || null : null;
  } catch {
    return null;
  }
}

function writeToCookie(value: string): void {
  try {
    document.cookie = `${GUEST_ID_KEY}=${encodeURIComponent(value)}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
  } catch {
    // Cookie write may fail in sandboxed contexts — not critical
  }
}

export function getOrCreateGuestId(): string {
  // Try localStorage first
  try {
    const fromStorage = localStorage.getItem(GUEST_ID_KEY);
    if (fromStorage) {
      writeToCookie(fromStorage);
      return fromStorage;
    }
  } catch {
    // localStorage may be unavailable
  }

  // Fall back to cookie
  const fromCookie = readFromCookie();
  if (fromCookie) {
    try {
      localStorage.setItem(GUEST_ID_KEY, fromCookie);
    } catch {}
    return fromCookie;
  }

  // Generate fresh ID
  const id = randomUUID();
  try {
    localStorage.setItem(GUEST_ID_KEY, id);
  } catch {}
  writeToCookie(id);
  return id;
}
